import React from 'react';
import Link from 'next/link';
import Icon from '@/components/ui/AppIcon';

interface EmergencyResource {
  id: string;
  title: string;
  description: string;
  icon: string;
}

interface EmergencyResourcesProps {
  resources: EmergencyResource[];
}

const EmergencyResources = ({ resources }: EmergencyResourcesProps) => {
  return (
    <div className="bg-gradient-to-br from-error to-error/80 rounded-xl shadow-elevated p-6 text-white">
      <div className="flex items-center space-x-3 mb-4">
        <Icon name="ExclamationTriangleIcon" size={28} variant="solid" className="text-white" />
        <h3 className="text-xl font-headline font-bold">Emergency Resources</h3>
      </div>

      <p className="text-white/90 mb-6">
        Quick access to critical care information for urgent pet situations
      </p>

      <div className="space-y-3">
        {resources.map((resource) => (
          <div
            key={resource.id}
            className="flex items-start space-x-3 p-4 bg-white/10 backdrop-blur-sm rounded-lg hover:bg-white/20 transition-colors"
          >
            <Icon name={resource.icon as any} size={20} variant="outline" className="text-white flex-shrink-0 mt-0.5" />
            <div>
              <h4 className="font-semibold mb-1">{resource.title}</h4>
              <p className="text-sm text-white/80">{resource.description}</p>
            </div>
          </div>
        ))}
      </div>

      <Link
        href="/emergency-resources"
        className="mt-6 w-full flex items-center justify-center space-x-2 px-6 py-3 bg-white text-error rounded-lg hover:shadow-elevated transition-all duration-300 font-semibold"
      >
        <span>View All Emergency Resources</span>
        <Icon name="ArrowRightIcon" size={18} variant="outline" />
      </Link>
    </div>
  );
};

export default EmergencyResources;